import initData from 'init-data';

export default {
    AVAILABLE_SHIPPING_COUNTRIES: initData.availableShippingCountriesUrl,
    BANK_ID_AUTHENTICATE: initData.bankIdAuthenticateUrl,
    BANK_ID_PROGRESS: initData.bankIdProgressUrl,
    BID_ITEM: itemId => `/api/webapi/shopping/biditem/${itemId}`,
    BRAND_PAGE: initData.brandPageUrl,
    BRAND_LIST_PAGE: initData.brandListPageUrl,
    CAMPAIGN: campaignId =>
        '/campaign/api/{campaignId}'.replace('{campaignId}', campaignId),
    CMS_API: initData.cmsApiUrl,
    CHARITY_EARNINGS_TICKER: initData.charityEarningsTickerUrl,
    FAVORITE_SELLER_ADD: initData.favoriteSellerAddUrl,
    FAVORITE_SELLER_REMOVE: initData.favoriteSellerRemoveUrl,
    GET_CATEGORY_LIST: initData.getCategoryListUrl,
    GET_ITEM: initData.getItemUrl,
    GEO_PUBLIC_API_URL: initData.geoPublicApiUrl,
    HYPERWALLET_PAYOUT: initData.hyperwalletPayoutUrl,
    HYPERWALLET_PAYOUT_TOKEN: initData.hyperwalletPayoutTokenUrl,
    HYPERWALLET_PAYOUT_COMPLETE: initData.hyperwalletPayoutCompleteUrl,
    ITEM_DESCRIPTION: itemId =>
        initData.itemDescriptionUrl.replace('$itemId', itemId),
    ITEM_DISCOUNT_QUOTA: initData.settingsQuotaUrl,
    LAST_CHANCE: initData.lastChanceUrl,
    LOGIN_STATE: initData.loginStateUrl,
    MEMBER_PAYOUT_SETTINGS: initData.memberPayoutSettingsUrl,
    MEMBER_PAYOUT_SETTINGS_REMOVE: initData.memberPayoutSettingsRemoveUrl,
    MEMBER_SYSTEM_MESSAGES: initData.memberSystemMessagesUrl,
    MESSAGING_EMAIL_SETTINGS: initData.messagingEmailSettingsUrl,
    MESSAGING_NOTIFICATIONS: initData.messagingNotificationsUrl,
    MESSAGING_PARTICIPATION: initData.messagingParticipationUrl,
    MESSAGING_SET_PARTICIPATION: initData.messagingSetParticipationUrl,
    ORDER_CHECKOUT_CONFIRMATION: initData.orderCheckoutConfirmationtUrl,
    ORDER_CHECKOUT_COMPLETE_PAYMENT: initData.orderCheckoutCompletePaymentUrl,
    ORDER_CHECKOUT_INIT_PAYMENT: initData.orderCheckoutInitializePaymentUrl,
    ORDER_CHECKOUT_AUTH_DATA: initData.orderCheckoutAuthenticationDataUrl,
    ORDER_CHECKOUT_PAYMENT_OPTIONS: initData.orderCheckoutPaymentUrl,
    ORDER_CHECKOUT_PAYMENT_STATUS: initData.orderCheckoutPaymentStatusUrl,
    ORDER_CHECKOUT_VIEW: initData.orderCheckoutViewUrl,
    ORDER_CHECKOUT_PAYMENT: initData.orderCheckoutPaymentUrl,
    PAYMENT_SWISH_OPTOUT: initData.paymentSwishOptoutUrl,
    SAVED_SEARCH_ADD: initData.savedSearchAddUrl,
    SAVED_SEARCH_NOTIFICATION: initData.savedSearchNotificationUrl,
    SAVED_SEARCH_REMOVE: initData.savedSearchRemoveUrl,
    SEARCH: initData.searchBaseUrl,
    SEARCH_SUGGESTIONS: initData.searchSuggestionsUrl,
    SELLING_ATTRIBUTES: initData.sellingAttributesUrl,
    SELLING_CATEGORY_RESTRICTIONS: initData.sellingCategoryRestrictionsUrl,
    SETTINGS: initData.settingsUrl,
    SHIPPING_BAGS_ORDER: '/api/webapi/selling/add-shipping-bags-order',
    SHIPPING_BAGS_ORDER_COUNT_FOR_ITEM: itemId =>
        `/api/webapi/selling/shipping-bags-order/${itemId}`,
    SHIPPING_BAGS_ORDER_COUNT_TOTAL:
        '/api/webapi/selling/shipping-bags-order-count ',
    SHIPPING_PROVIDERS: initData.shippingProvidersUrl,
    WEB_API: initData.webApiUrl,
    WISHLIST_ADD: initData.wishlistAddUrl,
    WISHLIST_REMOVE: initData.wishlistRemoveUrl
};
